import { useState } from 'react';

import ActionButton from '../actionbutton/ActionButton';

import CloseIcon from 'assets/icons/close-card-icon.svg';

import classes from './Card.module.scss';

const Card = ({ imageURL, actions, title, subTitle, className }) => {
	const [show, setShow] = useState(true);
	return (
		<>
			{show && (
				<div className={`${classes['card']} ${className} container p-0`}>
					<div className={`${classes['image-container']} col-12 col-md-5`}>
						<CloseIcon data-testid="card-closebtn" onClick={() => setShow(false)} />
						<img src={imageURL} alt="" className={`${classes['card-image']}`} />
					</div>
					<div className={`${classes['card-content']} col-12 col-md-7`}>
						<h3 className={`${classes['card-subtitle']}`}>{subTitle}</h3>
						<h1 className={`${classes['card-title']}`}>{title}</h1>
						<div className={`${classes['card-actions']}`}>
							{actions.map((action, index) => (
								<ActionButton
									className={classes['card-action-button']}
									key={index}
									onClick={action.callback}>
									{action.label}
								</ActionButton>
							))}
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default Card;
